import { inject, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { FolderGlobalStore } from 'packages/client/src/app/store/medicalService/folder.global-store';

@Injectable()
export class FolderServiceMailRecordsStore extends ComponentStoreV2Factory {
    public readonly folderStore = inject(FolderGlobalStore);
    isTerminated = this.folderStore.isTerminated;
    //
    // folder = globalStore!.selectSignal(selectFolder);
    // folderId = globalStore!.selectSignal(selectFolderId);
    //serviceId = globalStore!.selectSignal(selectCurrentServiceId);
}
